
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[slug]/onboarding-estudiante/bienvenido",
      function () {
        return require("private-next-pages/org/[slug]/onboarding-estudiante/bienvenido.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[slug]/onboarding-estudiante/bienvenido"])
      });
    }
  